import { getRidOfDiacritics } from './getRidOfDiacritics';

export const getInputVariableValue = (value: string) =>
  getRidOfDiacritics(value).replace(/\s/g, '_');
